import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const PricingCard = ({ item, type = 'package' }) => {
  const [period, setPeriod] = useState('monthly');
  const navigate = useNavigate();

  const handlePurchase = (selectedPeriod) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      navigate('/login');
      return;
    }

    let price, original;
    if (type === 'service') {
      price = item.price;
      original = item.price;
    } else {
      price = item.pricing[selectedPeriod].price;
      original = item.pricing[selectedPeriod].original;
    }

    navigate('/payment', {
      state: {
        item: {
          ...item,
          selectedPeriod,
          price,
          original,
          type
        }
      }
    });
  };

  return (
    <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 border border-green-500/30 rounded-2xl p-6 hover:border-green-500 transition-all duration-300 hover:shadow-xl hover:shadow-green-500/20 group h-full flex flex-col">
      <div className="mb-4">
        <h3 className="text-2xl font-bold text-green-400 mb-2 group-hover:text-green-300 transition-colors">
          {item.name}
        </h3>
        <p className="text-gray-400 text-sm">{item.description}</p>
      </div>

      {type === 'service' ? (
        <div className="mb-6">
          <div className="flex items-baseline">
            <span className="text-4xl font-bold text-white">{item.price}</span>
            <span className="text-gray-400 ml-2">TL / {item.period}</span>
          </div>
        </div>
      ) : (
        <>
          <div className="flex justify-center mb-6 bg-gray-800/50 rounded-lg p-1">
            <button
              onClick={() => setPeriod('monthly')}
              className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-all ${
                period === 'monthly'
                  ? 'bg-green-500 text-black'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              Aylık
            </button>
            <button
              onClick={() => setPeriod('sixMonth')}
              className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-all ${
                period === 'sixMonth'
                  ? 'bg-green-500 text-black'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              6 Aylık
            </button>
            <button
              onClick={() => setPeriod('yearly')}
              className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-all ${
                period === 'yearly'
                  ? 'bg-green-500 text-black'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              Yıllık
            </button>
          </div>

          <div className="mb-6">
            <div className="flex items-baseline">
              <span className="text-4xl font-bold text-white">{item.pricing[period].price}</span>
              <span className="text-gray-400 ml-2">TL</span>
            </div>
            {item.pricing[period].original !== item.pricing[period].price && (
              <div className="flex items-center mt-1">
                <span className="text-gray-500 line-through text-sm">{item.pricing[period].original} TL</span>
                <span className="text-green-400 text-xs ml-2">İndirim!</span>
              </div>
            )}
          </div>
        </>
      )}

      <div className="space-y-3 mb-6 flex-grow">
        {item.features.map((feature, index) => (
          <div key={index} className="flex items-start">
            <div className="flex-shrink-0 mt-1">
              <div className="w-5 h-5 bg-green-500/20 rounded-full flex items-center justify-center">
                <Check className="w-3 h-3 text-green-400" />
              </div>
            </div>
            <span className="ml-3 text-gray-300 text-sm">{feature}</span>
          </div>
        ))}
      </div>

      {type === 'service' ? (
        <Button
          onClick={() => handlePurchase('monthly')}
          className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-black font-semibold py-3 transform hover:scale-105 transition-transform"
        >
          Satın Al
        </Button>
      ) : (
        <div className="space-y-2">
          <Button
            onClick={() => handlePurchase('monthly')}
            variant="outline"
            className="w-full border-green-500 text-green-400 hover:bg-green-500 hover:text-black transition-all"
          >
            Aylık Satın Al
          </Button>
          <Button
            onClick={() => handlePurchase('sixMonth')}
            variant="outline"
            className="w-full border-green-500 text-green-400 hover:bg-green-500 hover:text-black transition-all"
          >
            6 Aylık Satın Al
          </Button>
          <Button
            onClick={() => handlePurchase('yearly')}
            className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-black font-semibold transform hover:scale-105 transition-transform"
          >
            Yıllık Satın Al
          </Button>
        </div>
      )}
    </div>
  );
};

export default PricingCard;